import { render, staticRenderFns } from "./MotoristaGastoRead.vue?vue&type=template&id=2b28ee12&"
import script from "./MotoristaGastoRead.vue?vue&type=script&lang=js&"
export * from "./MotoristaGastoRead.vue?vue&type=script&lang=js&"
import style0 from "./MotoristaGastoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports